import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("customer_insights.label.somos1_data_entry"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        {
          attrs: { class_table: _vm.getClassTable },
          scopedSlots: _vm._u([
            {
              key: "description",
              fn: function () {
                return [
                  _c(VBreadcrumbs, {
                    staticClass: "pa-0",
                    attrs: { items: _vm.getBreadcrumbs },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "actions" },
            [
              _vm.isAdmin
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-1 btn-inca-secondary",
                      attrs: {
                        dense: "",
                        outlined: "",
                        loading: _vm.loading_log,
                        disabled: _vm.loading_log,
                      },
                      on: { click: _vm.download_log },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-download"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("customer_insights.button.download_log")
                          ) +
                          " "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAdmin
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-1 btn-inca-secondary",
                      attrs: {
                        dense: "",
                        outlined: "",
                        loading: _vm.loading,
                        disabled: _vm.loading,
                      },
                      on: { click: _vm.download },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-download"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("customer_insights.button.download")) +
                          " "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canUpload
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-1 btn-inca-secondary",
                      attrs: { dense: "", outlined: "" },
                      on: { click: _vm.uploadForecast },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-upload"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("customer_insights.forecast.title")) +
                          " "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canUpload
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-1 btn-inca-secondary",
                      attrs: { dense: "", outlined: "" },
                      on: { click: _vm.uploadBudget },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-upload"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "customer_insights.bulk_upload.budget_upload_btn"
                            )
                          ) +
                          " "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canUpload
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-1 btn-inca-secondary",
                      attrs: { dense: "", outlined: "" },
                      on: { click: _vm.uploadKPIs },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-upload"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("customer_insights.bulk_upload.title")
                          ) +
                          " "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("customer_insights.button.filter")) +
                      " "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              [
                _c(VDataTable, {
                  staticClass: "text-center table-inca",
                  attrs: {
                    headers: _vm.headers,
                    "items-per-page": 100,
                    items: _vm.items,
                    "sticky-header": true,
                    "hide-default-footer": "",
                    hover: "",
                    "item-class": "table-inca-no_data",
                    responsive: "",
                    "group-by": "region",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "no-data",
                        fn: function () {
                          return [
                            _c("StateComponent", {
                              attrs: {
                                state: "empty_state",
                                title: "Aún no tienes Entradas de datos.",
                                subtitle:
                                  "Una vez que te los proporcionen podrás verlos aquí",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      _vm._l(
                        _vm.headers.filter(function (header) {
                          return header.hasOwnProperty("formatter")
                        }),
                        function (header) {
                          return {
                            key: "item." + header.value,
                            fn: function (ref) {
                              var header = ref.header
                              var value = ref.value
                              return [
                                _vm._v(
                                  " " + _vm._s(header.formatter(value)) + " "
                                ),
                              ]
                            },
                          }
                        }
                      ),
                      {
                        key: "group.header",
                        fn: function (ref) {
                          var items = ref.items
                          var isOpen = ref.isOpen
                          var toggle = ref.toggle
                          var group = ref.group
                          return [
                            _c(
                              "th",
                              { attrs: { colspan: _vm.headers.length } },
                              [
                                _c(
                                  VRow,
                                  { attrs: { dense: "" } },
                                  [
                                    _c(VCol, [
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            VIcon,
                                            {
                                              staticClass: "mr-0",
                                              attrs: { left: "" },
                                              on: { click: toggle },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  isOpen
                                                    ? "mdi-chevron-right"
                                                    : "mdi-chevron-down"
                                                ) + " "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            " " + _vm._s(items[0].region) + " "
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VForm,
                  {
                    ref: "form",
                    staticClass: "form",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.valid,
                      callback: function ($$v) {
                        _vm.valid = $$v
                      },
                      expression: "valid",
                    },
                  },
                  [
                    _c(
                      VCard,
                      { staticClass: "filters-inca" },
                      [
                        _c(
                          VCardTitle,
                          {
                            staticClass: "pointer",
                            on: {
                              click: function ($event) {
                                _vm.collapse_filter = !_vm.collapse_filter
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("titles.search_filters")) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          VCardText,
                          { staticClass: "pa-2 pt-0" },
                          [
                            _c(
                              VRow,
                              { attrs: { dense: "dense" } },
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(VSelect, {
                                      attrs: {
                                        label: _vm.$t(
                                          "customer_insights.label.organization"
                                        ),
                                        name: "id_organization",
                                        placeholder: _vm.$t(
                                          "customer_insights.label.organization"
                                        ),
                                        items: _vm.organizationsList,
                                        rules: _vm.rules.organization,
                                        "item-value": "id_organization",
                                        "item-text": "name",
                                        outlined: "",
                                        dense: "",
                                      },
                                      on: { change: _vm.changeOrganization },
                                      model: {
                                        value: _vm.organization_id,
                                        callback: function ($$v) {
                                          _vm.organization_id = $$v
                                        },
                                        expression: "organization_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(VSelect, {
                                      attrs: {
                                        label: _vm.$t(
                                          "customer_insights.label.tipo_reporte"
                                        ),
                                        name: "id_tipo_reporte",
                                        placeholder: _vm.$t(
                                          "customer_insights.label.tipo_reporte"
                                        ),
                                        items: _vm.tipoReporteList,
                                        rules: _vm.rules.tipo_reporte,
                                        "item-value": "id",
                                        "item-text": "name",
                                        outlined: "",
                                        dense: "",
                                      },
                                      on: { change: _vm.changeTipoReporte },
                                      model: {
                                        value: _vm.tipo_reporte_id,
                                        callback: function ($$v) {
                                          _vm.tipo_reporte_id = $$v
                                        },
                                        expression: "tipo_reporte_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(VSwitch, {
                                      attrs: {
                                        label: _vm.$t(
                                          "customer_insights.label.general_indicators"
                                        ),
                                      },
                                      on: { change: _vm.changeSwitch },
                                      model: {
                                        value: _vm.filtro.isGeneral,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filtro, "isGeneral", $$v)
                                        },
                                        expression: "filtro.isGeneral",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                !_vm.filtro.isGeneral
                                  ? _c(
                                      VCol,
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(VSelect, {
                                          attrs: {
                                            label: _vm.$t(
                                              "customer_insights.label.brand"
                                            ),
                                            name: "id_brand",
                                            placeholder: _vm.$t(
                                              "customer_insights.label.brand"
                                            ),
                                            items: _vm.brandsList,
                                            rules: _vm.rules.brand,
                                            "item-value": "id_brand",
                                            "item-text": "name",
                                            outlined: "",
                                            dense: "",
                                          },
                                          on: { change: _vm.changeBrand },
                                          model: {
                                            value: _vm.brand_id,
                                            callback: function ($$v) {
                                              _vm.brand_id = $$v
                                            },
                                            expression: "brand_id",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  VCol,
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(VSelect, {
                                      attrs: {
                                        label: _vm.$t(
                                          "customer_insights.label.indicator"
                                        ),
                                        name: "id_indicator",
                                        placeholder: _vm.$t(
                                          "customer_insights.label.indicator"
                                        ),
                                        items: _vm.indicatorsList,
                                        rules: _vm.rules.indicator,
                                        "item-value": "id_indicator",
                                        "item-text": "name",
                                        outlined: "",
                                        dense: "",
                                      },
                                      model: {
                                        value: _vm.indicator_id,
                                        callback: function ($$v) {
                                          _vm.indicator_id = $$v
                                        },
                                        expression: "indicator_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(VSelect, {
                                      attrs: {
                                        multiple: "",
                                        name: "id_region",
                                        label: _vm.$t(
                                          "customer_insights.label.region"
                                        ),
                                        placeholder: _vm.$t(
                                          "customer_insights.label.region"
                                        ),
                                        chips: "",
                                        outlined: "",
                                        dense: "",
                                        items: _vm.regionsList,
                                        "item-value": "id_region",
                                        "item-text": "name",
                                      },
                                      model: {
                                        value: _vm.region_id,
                                        callback: function ($$v) {
                                          _vm.region_id = $$v
                                        },
                                        expression: "region_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-md-12 text-right" },
                                  [
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "default mr-1",
                                        attrs: { outlined: "outlined" },
                                        on: { click: _vm.onLimpiar },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                    ),
                                    _vm.tipo_reporte_id == 1
                                      ? _c(
                                          VBtn,
                                          {
                                            staticClass: "primary",
                                            on: { click: _vm.onSearch },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("btns.search"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.tipo_reporte_id > 1
                                      ? _c(
                                          VBtn,
                                          {
                                            staticClass: "primary",
                                            on: {
                                              click: function ($event) {
                                                return _vm.onSearchBudget(
                                                  _vm.tipo_reporte_id - 1
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("btns.search"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("dialogs-component", {
        ref: _vm.DIALOG_DATA_ENTRY_UPLOAD,
        attrs: {
          title: _vm.$t("customer_insights.bulk_upload.title"),
          "show-buttons": true,
          width: 900,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  [
                    _c("somos1-data-entry-bulk-upload", {
                      ref: "somos1DataEntryBulkUpload",
                      on: {
                        "update:disabled": _vm.handleDisabledUpdate,
                        close: function ($event) {
                          return _vm.onCloseDialog(_vm.DIALOG_DATA_ENTRY_UPLOAD)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary", disabled: _vm.disabled },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.somos1DataEntryBulkUpload.onSubmit(
                          $event
                        )
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { small: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("customer_insights.button.send")) +
                        " "
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_DATA_ENTRY_UPLOAD_BUDGET,
        attrs: {
          title: _vm.$t("customer_insights.bulk_upload.budget_upload_btn"),
          "show-buttons": true,
          width: 900,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  [
                    _c("somos1-budget-upload", {
                      ref: "somos1DataEntryBudgetUpload",
                      on: {
                        "update:disabledBudget": _vm.handleDisabledBudgetUpdate,
                        close: function ($event) {
                          return _vm.onCloseDialog(
                            _vm.DIALOG_DATA_ENTRY_UPLOAD_BUDGET
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary", disabled: _vm.disabledBudget },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.somos1DataEntryBudgetUpload.onSubmit(
                          $event
                        )
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { small: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("customer_insights.button.send")) +
                        " "
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_DATA_ENTRY_UPLOAD_FORECAST,
        attrs: {
          title: _vm.$t("customer_insights.forecast.upload_btn"),
          "show-buttons": true,
          width: 900,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  [
                    _c("somos1-forecast-upload", {
                      ref: "somos1DataEntryForecastUpload",
                      on: {
                        "update:disabledBudget":
                          _vm.handleDisabledForecastUpdate,
                        close: function ($event) {
                          return _vm.onCloseDialog(
                            _vm.DIALOG_DATA_ENTRY_UPLOAD_FORECAST
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary", disabled: _vm.disabledBudget },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.somos1DataEntryForecastUpload.onSubmit(
                          $event
                        )
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { small: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("customer_insights.button.send")) +
                        " "
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }